import { useMemo } from 'react';

import { setCheckedEthnicity, useCheckedEthnicity } from 'reducers/viewsSlice';

import { VIEWS_FILTER_KEYS } from 'constants/ProjectConstants';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

import { useEthnicity } from '../../Hooks/dataHooks';
import { AgGridContainer } from './AgGridContainer';

const CellRenderer = ({ data: ethnicity }) => (
  <ListItemComp title={ethnicity.displayName} isBoldText={false} withoutBackground padding="16px 24px" />
);

export const Ethnicity = () => {
  const { data: ethnicity, isLoading } = useEthnicity();
  const checkedEthnicity = useCheckedEthnicity();

  const columnDefs = useMemo(
    () => [
      {
        colId: VIEWS_FILTER_KEYS.ETHNICITY,
        flex: 1,
        cellRenderer: CellRenderer,
        getQuickFilterText: (params) => params.data.displayName,
        sortable: true,
        comparator: (_valueA, _valueB, nodeA, nodeB) => {
          const a = nodeA.data.displayName;
          const b = nodeB.data.displayName;
          return a.localeCompare(b);
        },
      },
    ],
    []
  );

  return (
    <AgGridContainer
      rowData={ethnicity}
      columnDefs={columnDefs}
      setCheckedRows={setCheckedEthnicity}
      sortColumnId={VIEWS_FILTER_KEYS.ETHNICITY}
      checkedRows={checkedEthnicity}
      rowCheckedTesterFn={({ nodeData, checkedRows }) => {
        const { displayName: nodeDataDisplayName } = nodeData || {};
        const checked = checkedRows?.find(({ displayName }) => displayName === nodeDataDisplayName);
        return !!checked;
      }}
    />
  );
};
